import { extractHeadings } from '../lib/content-loader';
import './TOC.css';

type Props = {
  body: string;
};

export function TOC({ body }: Props) {
  const headings = extractHeadings(body);
  if (headings.length === 0) {
    return <aside className="ds-toc" aria-label="Table of contents" />;
  }
  return (
    <aside className="ds-toc" aria-label="Table of contents">
      <div className="ds-toc-head">On this page</div>
      {headings.map(h => (
        <a
          key={`${h.level}-${h.id}`}
          className={`ds-toc-link${h.level === 3 ? ' h3' : ''}`}
          href={`#${h.id}`}
        >
          {h.text}
        </a>
      ))}
    </aside>
  );
}
